import React, { Component } from "react";

function App(props) {
  return (
    <section className="content-header titulo-header">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h4>{props.texto}</h4>
            <hr/> 
            <br/>
          </div>
        </div>
      </div>
    </section>
  ) 
}
 
export default App;